import { render } from "./DriveAddPhotos.vue?vue&type=template&id=c116d18e&scoped=true&ts=true"
import script from "./DriveAddPhotos.vue?vue&type=script&lang=ts"
export * from "./DriveAddPhotos.vue?vue&type=script&lang=ts"

import "./DriveAddPhotos.vue?vue&type=style&index=0&id=c116d18e&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c116d18e"]])

export default __exports__